import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Box, Stack } from '@mui/material';
import { Button, Popover, Tooltip } from 'antd';
import { components } from 'react-select';
import { FiPlus } from 'react-icons/fi';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

import ProductImg from '../../assets/images/newImages/nestle.svg';
import copyIcon from '../../assets/images/newImages/copy-white-icon.svg';
import linkIcon from '../../assets/images/newImages/icon-link.svg';
import EditIcon from '../../assets/images/edit-icon.svg';
import Info from '../../assets/icons/info-alert-1.svg';
import InfoIcon from '../../assets/images/newImages/info-icon-blue.svg';
import { UnLinkItem, removeMappedItem, CheckWorkOrderLinkStatus } from '../../slices/3-layer-products';

import EditSkuQtyModal from './EditSkuQtyModal';
import AddVendorEditVendor from './addVendor_editVendor.jsx';
import { copyToClip } from '../../utils/utils';
import { OPEN_PRODUCT_TO_AMAZON_URL } from '../../constants/threeLayer';

import { TableStyleWrapper } from './style';
import { UnlinkVendorItem } from '../../slices/vendor-items.js';


const ProductRowDetails = (props) => {
  const dispatch = useDispatch();

  const [showEditSkuModal, setShowEditSkuModal] = useState(false);
  const [rowIndex, setRowIndex] = useState(-1);
  const [isLinkPopover, setIsLinkPopover] = useState();
  const [isVendorItems, setIsVendorItems] = useState(false);
  const [addVendor, setAddVendor] = useState();
  const [editVendor, setEditVendor] = useState();
  const [editedVendorItem, setEditedVendorItem] = useState({});
  const [createVendorItem, setCreateVendorItem] = useState({});
  const [activeTabs, setActiveTabs] = useState('sku');

  const { handleRefreshPageData, openMapSkuModal, setShowMappingAlert, data } = props;
  const { seller_skus, id: product_id, image_url, name, identifier_value, vendor_items_v2 } = data || {};

  const {
    products
  } = useSelector((state) => state.threeLayerProducts || {});

  const { currentUser } = useSelector(state => state.auth);

  const handleUnLinkSku = (sku_id) => {
    dispatch(UnLinkItem({
      sku_id,
      product_id
    })).then(({ payload }) => {
      if (payload?.success) {
        dispatch(removeMappedItem({ field: 'products', parentId: product_id, key: 'seller_skus', childId: sku_id }));
        props?.expandRow(product_id);
      }
      else if (!isEmpty(payload?.errorData)) handleShowMappingAlert();
    });
  };

  const handleUnLinkVendorItem = (id) => {
    dispatch(UnlinkVendorItem({ id })).then(({ payload }) => {
      if (payload?.success) {
        dispatch(removeMappedItem({ field: 'products', parentId: product_id, key: 'vendor_items_v2', childId: id }));
        props?.expandRow(product_id);
      }
    });
  };

  const handlePopoverClick = (e, data) => {
    e.stopPropagation();
    setIsLinkPopover(data.id);
  };

  const columnDefs = [
    {
      headerName: 'Product',
      minWidth: 150,
      flex: 2,
      resizable: true,
      cellRenderer: ({ data }) => {
        const { image_url, item_name, sku, vendorasin } = data || {};

        return (
          <div className="product-title">
            <img src={image_url || ProductImg} alt="product" width={28} height={28} className='product-img'
              style={{ cursor: 'pointer' }}
              onClick={() => window.open(`${OPEN_PRODUCT_TO_AMAZON_URL}/${vendorasin?.asin}`, '_blank')}
            />
            <div className='w-100'>
              <Tooltip placement="bottom" title={item_name}>
                <span
                  className="product-name"
                  style={{ cursor: 'pointer' }}
                  onClick={() => window.open(`${OPEN_PRODUCT_TO_AMAZON_URL}/${vendorasin?.asin}`, '_blank')}
                >
                  {item_name}
                </span>
              </Tooltip>
              <div className='d-flex align-items-center gap-2'>
                <div className='asin'>
                  <span><span>{vendorasin?.asin}</span></span>
                  <img src={copyIcon} alt='copy' className='cursor-pointer'
                    onClick={() => copyToClip(vendorasin?.asin)} />
                </div>
                <div className='asin sku'>
                  <span><span>{sku}</span></span>
                  <img src={copyIcon} alt='copy' className='cursor-pointer'
                    onClick={() => copyToClip(sku)} />
                </div>
              </div>
            </div>
          </div>
        );
      }
    },
    {
      headerName: 'Pack Qty',
      minWidth: 120,
      flex: 1,
      resizable: true,
      field: 'product_sku_mappings_v2.bundle_quantity'
    },
    // {
    //   headerName: 'WH Reserved Quantity',
    //   minWidth: 120,
    //   flex: 1,
    //   resizable: true,
    //   field: "reserved_qty",
    //   cellRenderer: ({ value }) => value || 0
    // },
    {
      headerName: 'ASV (90D)',
      minWidth: 200,
      flex: 1,
      field: 'adjusted_sales_velocity',
      resizable: true,
      comparator: () => 0,
      cellRenderer: ({ value, data }) => {
        let displayValue;
        if (value == null || value === '' || value === 0 || value === '0.00') {
          displayValue = '-';
        } else {
          const num = Number(value);
          displayValue = Number.isInteger(num) ? num.toString() : num.toFixed(2);
        }
        
        const tooltipContent = (
          <div style={{ minWidth: '300px' }}>
            <div>Total Ordered Units (90 Days): {Math.floor(data?.ordered_units ?? 0)}</div>
            <div>In Stock Days (90 Days): {data?.in_stock_days ?? 0}</div>
            <div>Adjusted Sales Velocity (90 Days): {displayValue === '-' ? 0 : displayValue}</div>
          </div>
        );
        
        return (
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {displayValue}
            <Tooltip title={tooltipContent} placement="top">
              <img src={InfoIcon} alt="info" style={{ width: '14px', height: '14px', cursor: 'pointer' }} />
            </Tooltip>
          </span>
        );
      }
    },
    {
      headerName: 'Price',
      minWidth: 120,
      flex: 1,
      resizable: true,
      field: 'price',
      cellRenderer: ({ value }) => value ? `$${value}` : 0
    },
    {
      headerName: 'AMZ Total',
      minWidth: 100,
      field: 'amazon_total',
      flex: 1,
      resizable: true,
      cellRenderer: ({ value }) => value ?? 0
    },
    {
      headerName: 'AMZ Available',
      minWidth: 100,
      field: 'amazon_available',
      flex: 1,
      resizable: true,
      cellRenderer: ({ value }) => value ?? 0

    },
    {
      headerName: 'Action',
      width: 100,
      cellRenderer: ({ data, node }) => {
        return (
          <div className='d-flex align-items-center gap-2'>
            <img src={EditIcon} alt='edit' className='cursor-pointer'
              onClick={() => {
                dispatch(CheckWorkOrderLinkStatus({
                  id: product_id,
                  idType: 'product'
                }))
                  .then(({ payload }) => {
                    if (payload?.success) {
                      setRowIndex(node.rowIndex);
                      setShowEditSkuModal(true);
                    }
                    else setShowMappingAlert(true);
                  });
              }}
            />
            <Popover
              placement="left"
              visible={isLinkPopover === data.id}
              trigger="click"
              content={
                <TableStyleWrapper>
                  <div className="alert-popover-wrapper">
                    <img src={Info} alt="Info" />
                    <span>Are you sure want to unlink?</span>
                  </div>
                  <div className="alert-popover-icons-wrapper">
                    <Button onClick={() => setIsLinkPopover(false)}>No</Button>
                    <Button onClick={() => handleUnLinkSku(data?.id)}>Yes</Button>
                  </div>
                </TableStyleWrapper>
              }
            >
              <img onClick={(e) => handlePopoverClick(e, data)} src={linkIcon} alt='link' className='cursor-pointer' />
            </Popover>
          </div>
        );
      }
    }
  ];

  const padToEightDigits = (number) => {
    return number.toString().padStart(8, '0');
  };

  const vendor_items_columnDefs = [
    {
      headerName: 'Vendor',
      field: 'vendor',
      sortable: true,
      resizable: true,
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ data }) => {
        return (
          <span>{data?.vendor_name || 'N/A'}</span>
        );
      }
    },
    {
      headerName: 'Item ID',
      field: 'id',
      sortable: true,
      resizable: true,
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ value }) => value ? padToEightDigits(value) : '-'
    },
    {
      headerName: 'Identifier',
      sortable: true,
      resizable: true,
      minWidth: 100,
      flex: 1,
      resizable: true,
      cellRenderer: ({ data }) => {
        return (
          <div className="upc-item-wrapper">
            <p>{data?.identifier_type?.toUpperCase() || 'N/A'}</p>
            <span>{data?.identifier_value || 'N/A'}</span>
            {/* <img src={copyIcon} alt='copy' className='cursor-pointer'
              onClick={() => copyToClip(data?.identifier_value)} /> */}
          </div>
        );
      }
    },
    {
      headerName: 'MOQ',
      field: 'moq',
      sortable: true,
      resizable: true,
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ data }) => {
        return (
          <span>{data?.minimum_order_quantity || 0}</span>
        );
      }
    },
    {
      headerName: 'Action',
      width: 100,
      cellRenderer: ({ data, node }) => {
        return (
          <div className='d-flex align-items-center gap-2'>
            <img src={EditIcon} alt='edit' className='cursor-pointer'
              onClick={() => {
                setRowIndex(node.rowIndex);
                // setShowEditSkuModal(true);
                setEditedVendorItem(data);
                setEditVendor(true);
              }}
            />
            {/* <Popover
              placement="left"
              visible={isLinkPopover === data.id}
              trigger="click"
              content={
                <TableStyleWrapper>
                  <div className="alert-popover-wrapper">
                    <img src={Info} alt="Info" />
                    <span>Are you sure want to unlink?</span>
                  </div>
                  <div className="alert-popover-icons-wrapper">
                    <Button onClick={() => setIsLinkPopover(false)}>No</Button>
                    <Button onClick={() => handleUnLinkVendorItem(data?.id)}>Yes</Button>
                  </div>
                </TableStyleWrapper>
              }
            >
              <img onClick={(e) => handlePopoverClick(e, data)} src={linkIcon} alt='link' className='cursor-pointer' />
            </Popover> */}
          </div>
        );
      }
    }
  ];

  const handleOpenMapSkuModal = () => {
    dispatch(CheckWorkOrderLinkStatus({
      id: product_id,
      idType: 'product'
    }))
      .then(({ payload }) => {
        if (payload?.success) {
          const index = products.findIndex(({ id }) => id === product_id);
          openMapSkuModal(index);
        }
        else setShowMappingAlert(true);
      });
  };

  useEffect(() => {
    const handleClick = () => {
      setIsLinkPopover(false);
    };

    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);

  const handleShowMappingAlert = () => {
    setShowEditSkuModal(false);
    setShowMappingAlert(true);
  };

  return (
    <TableStyleWrapper activeTabs={activeTabs}>
      <Box>
        <Box marginRight={1} display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" gap={1} marginLeft={1.5} marginTop={1.5}>
            <Button className="button-wrapper" onClick={() => setActiveTabs('sku')}>SKU's</Button>
            <Button className="button-wrapper" onClick={() => setActiveTabs('vendor')}>Vendor Items</Button>
          </Box>
          {activeTabs === 'sku' ?
            <Button className="map-btn-wrapper" variant="contained" onClick={handleOpenMapSkuModal}>MAP SKU</Button>
            : 
              <Button className="map-btn-wrapper" variant="contained" onClick={() => setIsVendorItems(true)}>Map Vendor Item</Button>
            }
        </Box>
        {activeTabs === 'sku' ? (
          <>
            <Box>
              <AgGridReact
                rowData={seller_skus}
                rowHeight={48}
                columnDefs={columnDefs}
                domLayout="autoHeight"
                className="sku-details-table"
              />
            </Box>
            {showEditSkuModal && (
              <EditSkuQtyModal
                open={showEditSkuModal}
                onHide={() => setShowEditSkuModal(false)}
                productData={{
                  id: product_id,
                  image_url,
                  name,
                  identifier_value
                }}
                skuIndex={rowIndex}
                sellerSkus={seller_skus}
                expandRow={props?.expandRow}
                handleShowMappingAlert={handleShowMappingAlert}
              />
            )}
          </>
        ) : activeTabs === 'vendor' ? (
          <>
            <AgGridReact
              rowData={vendor_items_v2}
              rowHeight={48}
              columnDefs={vendor_items_columnDefs}
              domLayout="autoHeight"
              className="sku-details-table"
            />
            {showEditSkuModal && (
              <EditSkuQtyModal
                open={showEditSkuModal}
                onHide={() => setShowEditSkuModal(false)}
                productData={{
                  id: product_id,
                  image_url,
                  name,
                  identifier_value
                }}
                skuIndex={rowIndex}
                sellerSkus={seller_skus}
                expandRow={props?.expandRow}
              />
            )}
          </>
        ) : null}
        <AddVendorEditVendor
          setAddVendor={setAddVendor}
          editVendor={editVendor}
          setEditVendor={setEditVendor}
          setIsVendorItems={setIsVendorItems}
          addVendor={addVendor}
          data={props?.data}
          isVendorItems={isVendorItems}
          editedVendorItem={editedVendorItem}
          setEditedVendorItem={setEditedVendorItem}
          createVendorItem={createVendorItem}
          setCreateVendorItem={setCreateVendorItem}
          expandRow={props?.expandRow}
        />
      </Box>
    </TableStyleWrapper>
  );
};

export default ProductRowDetails;
